<template>
	<div class="q_pad_lr15px">
		<div class="q_text_l q_bold q_center q_mar_t30px q_pad_lr20px">{{notice.noticeTitle}}</div>
		<div class="q_text_s q_color_gray q_center q_mar_t15px">{{notice.createTime}}</div>
		<div class="q_artdea q_mar_t15px">
      <div v-if="notice.isBack!='1'&&notice.deptId!=null">中队名称：{{dept.deptName}}</div>
      <div v-if="notice.isBack!='1'&&notice.deptId!=null">中队地址：{{dept.address}}</div>
		<div class="ql-editor" v-html="notice.noticeContent"></div>
    </div>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {getNoticeById} from "@/api/notice";
import {getJoinById} from "@/api/join";
import {wxCloseShare} from "@/utils/jiutang";

export default {
    name: 'Lamedea',
    props: {
      msg: String
    },
    data() {
      return {
        notice:{},
        noticeId:'',
        dept:{
          deptName:'',
          address:''
        }
      }
    },
    created() {
      wxCloseShare()
      this.noticeId = this.$route.query.id;
      this.init()
    },
    methods: {
      /**
       * 初始化
       */
      init() {
        this.$modal.loading()
        //获取通知详情信息
        getNoticeById(this.noticeId).then((res) => {
          this.notice = res.data
          if (res.data.isBack!='1'&&res.data.deptId!=null){
            //查询协会信息
            getJoinById(res.data.deptId).then(res=>{
              this.dept=res.data
            })
          }
        }).finally(() => {
          this.$modal.closeLoading()
        })
      },
    }
  }
</script>
<style>
	.q_artdea p{
		line-height: 24px;
		font-size: 14px;
		margin-bottom: 5px;
		text-align: justify;
	}
	.q_artdea img{
		max-width: 100%;
		margin: 10px auto;
		display: block;
	}
</style>
